import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataConditional } from '@onefootprint/request-types/dashboard';
import type { NodeProps } from '../../playbook-builder.types';
import BaseNode from '../base-node';
import { AddDefaultRules } from '../shared/add-default-rules';
import type { BranchesToRemoveByCategory, DefaultRuleSet } from '../shared/rule-suggestion-context.types';
import { RemoveUnallowedRules } from './components/remove-unallowed-rules';
import ConditionalForm from './conditional-form';
const ERR_CODE_SUGGESTED_RULE_ADDITION = 'E134';
const ERR_CODE_SUGGESTED_RULE_DELETION = 'E135';
const ConditionalNode = t0 => {
  const $ = _c(17);
  const {
    id,
    data
  } = t0;
  let t1;
  if ($[0] !== id) {
    t1 = t2 => {
      const {
        error,
        mutation,
        type
      } = t2;
      const rs = error.context as DefaultRuleSet | undefined;
      if (!rs?.defaultRules) {
        return null;
      }
      return <AddDefaultRules error={error} type={type} ruleSet={rs} nodeId={id} mutation={mutation} variant="conditional" />;
    };
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== id) {
    t2 = t3 => {
      const {
        error: error_0,
        mutation: mutation_0,
        type: type_0
      } = t3;
      const rs_0 = error_0.context as BranchesToRemoveByCategory | undefined;
      if (!rs_0?.branches) {
        return null;
      }
      return <RemoveUnallowedRules error={error_0} type={type_0} ruleSet={rs_0} nodeId={id} mutation={mutation_0} />;
    };
    $[2] = id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      [ERR_CODE_SUGGESTED_RULE_ADDITION]: t1,
      [ERR_CODE_SUGGESTED_RULE_DELETION]: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== data || $[8] !== id) {
    t4 = t5 => {
      const {
        mutation: mutation_1
      } = t5;
      return <ConditionalForm data={data} nodeId={id} mutation={mutation_1} />;
    };
    $[7] = data;
    $[8] = id;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = {
      form: "rules-form",
      size: "lg",
      customErrorComponents: t3,
      render: t4
    };
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== data || $[14] !== id || $[15] !== t5) {
    t6 = <BaseNode nodeId={id} data={data} collapsible={true} sidebar={t5} />;
    $[13] = data;
    $[14] = id;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default ConditionalNode;